<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Ajouter un role</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Retour à la liste</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleSubmit">
              <base-input
                label="Nom"
                prepend-icon="fas fa-user"
                v-model="role.name"
              />
              <validation-error :errors="apiValidationErrors.name" />
              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Ajouter un role
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
export default {
  layout: "DashboardLayout",

  mixins: [formMixin],

  components: {
    ValidationError,
  },

  data() {
    return {
      role: {
        type: "roles",
        name: null,
      },
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "Roles" });
    },

    async handleSubmit() {
      try {
        await this.$store.dispatch("roles/add", this.role);

        this.$notify({
          type: "success",
          message: "Role ajouté",
        });
        this.goBack();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oups, quelque chose s'est mal passé !",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
